//
// register.js
// Theme module
//

let APP_API = '//gateapi.shengyi.ai';

let form = {
  storename: '', // 店铺民称
  realname: '',
  account: '',
  password: '',
  // confirmPassword: '', // 确认密码
  // recommend: '', // 推荐人
  captcha: '', //图片验证码 (已废弃，使用滑块验证)
  sliderVerified: false, // 滑块验证状态
  vercode: '', //手机验证码
};
let token; // 图片验证码token (已废弃)
let isturn = true;


let host = window.location.pathname;
if (host == '/register.html') {
  // GetCapcode(); // 原图形验证码初始化 (已废弃)
  GetCapcodeForToken(); // 获取token (不显示图形验证码)
  initSliderVerification(); // 新的滑块验证初始化
  initPasswordToggle(); // 初始化密码显示/隐藏功能
}


function onSubmit () {
  var agc = ''
  var source = ''
  var accountName = form.account;
  var accountPwd = form.password;
  var storeName = form.storename;
  var userName = form.realname;
  // var recommendCode = form.recommend;
  var recommendCode = '';
  var vercode = form.vercode;

  try {
    var patternPhone = /^1[3458769]\d{9}$/;
    if (!patternPhone.test(accountName)) {
        ShowErrMsg("accountName", "请输入正确的手机号码！");
    }
    if (!vercode) {
        ShowErrMsg("verifyCode", "请输入正确的验证码！");
    }
    if (!storeName) {
        ShowErrMsg('storeName', '请输入店铺名称！');
    }
    if (!accountPwd) {
        ShowErrMsg('accountPwd', '请输入密码！');
    }
    // if (!form.confirmPassword) {
    //   ShowErrMsg('confirmPassword', '请输入确认密码！');
    // }
    // if (form.confirmPassword && (form.password !== form.confirmPassword)) {
    //     ShowErrMsg('confirmPassword', '两次输入的密码不一致！');
    // }
    var url = window.location.href;
    var querys = url.substring(url.indexOf('?') + 1).split('&');
    var result=[];
    for(var i=0;i<querys.length;i++){
        var temp=querys[i].split('=');
        if(temp.length<2){
            result[temp[0]]='';
        }else{
            result[temp[0]]=temp[1];
        }
    }

    var params = {
      account: accountName,
      password: accountPwd,
      storename: storeName,
      rec: recommendCode,
      agc: agc,
      vercode: vercode,
      realname: userName,
      source: source
    };

    const bodyJson = JSON.stringify(params);

    let xhr = new XMLHttpRequest();
    xhr.open('post', `${APP_API}/gatentry/apipub/reg/unireg` );
    xhr.setRequestHeader("content-type","application/json;charset=utf-8");
    // xhr.setRequestHeader("token",token); // 原图形验证码token (已废弃)
    if (token) {
      xhr.setRequestHeader("token", token); // 使用滑块验证获取的token
    }
    xhr.send(bodyJson);
    xhr.onreadystatechange = function () {
        // 这步为判断服务器是否正确响应
      if (xhr.readyState == 4 && xhr.status == 200) {

        let resp = JSON.parse(xhr.response);
        if (resp.code === 200 && resp.data.stat === '0000') {
          const newUrl = 'https://3.shengyi.ai/login'
          alert('注册成功');
          window.location.replace(newUrl);
        } else {
          alert(resp.data.desc);
        }
      } 
    };
  } catch (err) {
    alert(err);
  }
}

// 店铺名称
let Storename=document.getElementById("storename");
if (host == '/register.html') Storename.onchange = function getStorename() {
  form.storename = Storename.value;
}
// 店主姓名
let Realname=document.getElementById("realname");
if (host == '/register.html') Realname.onchange = function getRealname() {
  form.realname = Realname.value;
}
// 手机号码
let Account=document.getElementById("account");
if (host == '/register.html') {
  Account.onchange = function getAccount() {
    form.account = Account.value;
  }
  
  // 监听手机号码输入变化，重置滑动验证
  Account.oninput = function() {
    form.account = Account.value;
    resetSliderVerification();
  }
}
// 密码
let Password=document.getElementById("password");
if (host == '/register.html') Password.onchange = function getPassword() {
  form.password = Password.value;
}
// // 确认密码
// let ConfirmPassword=document.getElementById("confirmPassword");
// if (host == '/register.html') ConfirmPassword.onchange = function getConfirmPassword() {
//   form.confirmPassword = ConfirmPassword.value;
// }
// // 推荐人
// let Recommend=document.getElementById("recommend");
// if (host == '/register.html') Recommend.onchange = function getRecommend() {
//   form.recommend = Recommend.value;
// }
// 图片验证码 (已废弃，使用滑块验证)
// let Captcha=document.getElementById("captcha");
// if (host == '/register.html') Captcha.onchange = function getCaptcha() {
//   form.captcha = Captcha.value;
// }
// 手机验证码
let Vercode=document.getElementById("vercode");
if (host == '/register.html') Vercode.onchange = function getVercode() {
  form.vercode = Vercode.value;
}

// 获取验证码 (原图形验证码，已废弃)
// let codeImg = document.getElementById('codeSrc');
// if (host == '/register.html') codeImg.addEventListener('click', GetCapcode);

// 获取手机验证码
let phoneCodebtn = document.getElementById('phoneCodebtn');
if (host == '/register.html') phoneCodebtn.addEventListener('click', getSmsCode)

// 注册
let submit = document.getElementById('register');
if (host == '/register.html') submit.addEventListener('click', onSubmit);

// ========== 原图形验证码相关函数 (已废弃) ==========
// async function GetCapcode () {
//   await capcode()
// }

// function capcode (params) {
//   let xhr = new XMLHttpRequest();
//   xhr.open('get',`${APP_API}/gatentry/apipub/reg/capcode`);
//   xhr.send();
//   xhr.onreadystatechange = function () {
//     if (xhr.readyState == 4 && xhr.status == 200) {
//       let resp = JSON.parse(xhr.response);
//       if (resp.code == 200) {
//         codeImg.src = 'data:image/jpg;base64,' + resp.data.image
//         token = resp.data.token
//       }
//     }
//   }
// }
// ========== 原图形验证码相关函数结束 ==========

// ========== 获取token的函数 (用于滑块验证) ==========
async function GetCapcodeForToken() {
  await capcodeForToken()
}

function capcodeForToken() {
  let xhr = new XMLHttpRequest();
  xhr.open('get', `${APP_API}/gatentry/apipub/reg/capcode`);
  xhr.send();
  xhr.onreadystatechange = function () {
    if (xhr.readyState == 4 && xhr.status == 200) {
      let resp = JSON.parse(xhr.response);
      if (resp.code == 200) {
        // 不再设置图形验证码图片，只保存token
        // codeImg.src = 'data:image/jpg;base64,' + resp.data.image
        token = resp.data.token; // 保存token用于后续验证
        console.log('Token获取成功:', token); // 调试信息
      } else {
        console.error('Token获取失败:', resp);
        // 可以尝试重新获取
        setTimeout(() => {
          capcodeForToken();
        }, 2000);
      }
    } else if (xhr.readyState == 4) {
      console.error('Token请求失败:', xhr.status);
      // 网络错误时重试
      setTimeout(() => {
        capcodeForToken();
      }, 3000);
    }
  }
}
// ========== 获取token的函数结束 ==========

// ========== 新的滑块验证功能 ==========
// 初始化滑块验证
function initSliderVerification() {
  const sliderContainer = document.getElementById('sliderContainer');
  const sliderButton = document.getElementById('sliderButton');
  const sliderTrack = document.getElementById('sliderTrack');
  const sliderText = document.getElementById('sliderText');

  let isDragging = false;
  let startX = 0;
  let currentX = 0;
  let maxDistance = sliderContainer.offsetWidth - sliderButton.offsetWidth;

  // 初始化轨道状态
  sliderTrack.classList.add('not-dragging');

  // 鼠标事件
  sliderButton.addEventListener('mousedown', startDrag);
  document.addEventListener('mousemove', drag);
  document.addEventListener('mouseup', endDrag);

  // 触摸事件（移动端支持）
  sliderButton.addEventListener('touchstart', startDrag);
  document.addEventListener('touchmove', drag);
  document.addEventListener('touchend', endDrag);

  function startDrag(e) {
    if (form.sliderVerified) return;
    
    e.preventDefault();
    isDragging = true;
    sliderButton.classList.add('dragging');
    
    // 移除轨道的过渡效果，确保拖拽时立即跟随
    sliderTrack.classList.remove('not-dragging');
    
    // 获取滑块按钮的位置
    const buttonRect = sliderButton.getBoundingClientRect();
    
    // 计算鼠标在按钮内的相对位置
    const clientX = e.type === 'mousedown' ? e.clientX : e.touches[0].clientX;
    const offsetInButton = clientX - buttonRect.left;
    
    startX = clientX - offsetInButton;
    currentX = sliderButton.offsetLeft;
    
    // 更新最大距离
    maxDistance = sliderContainer.offsetWidth - sliderButton.offsetWidth;
    
    // 阻止文本选择
    document.body.style.userSelect = 'none';
    document.body.style.webkitUserSelect = 'none';
    document.body.style.mozUserSelect = 'none';
    document.body.style.msUserSelect = 'none';
  }

  function drag(e) {
    if (!isDragging || form.sliderVerified) return;
    
    e.preventDefault();
    
    // 获取当前鼠标位置
    const clientX = e.type === 'mousemove' ? e.clientX : e.touches[0].clientX;
    
    // 获取容器位置信息
    const containerRect = sliderContainer.getBoundingClientRect();
    
    // 计算新的按钮位置（直接基于鼠标在容器中的位置）
    let newX = clientX - containerRect.left - (sliderButton.offsetWidth / 2);
    
    // 限制滑动范围
    newX = Math.max(0, Math.min(newX, maxDistance));
    
    // 更新按钮位置和轨道宽度（使用transform提高性能）
    sliderButton.style.transform = `translateX(${newX}px)`;
    sliderButton.style.left = '0px'; // 重置left，使用transform
    sliderTrack.style.width = (newX + sliderButton.offsetWidth) + 'px';
    
    // 计算进度
    const progress = newX / maxDistance;
    
    // 根据进度更新文本透明度
    sliderText.style.opacity = 1 - progress;
    
    // 存储当前位置供endDrag使用
    sliderButton.dataset.currentX = newX;
  }

  function endDrag(e) {
    if (!isDragging) return;
    
    isDragging = false;
    sliderButton.classList.remove('dragging');
    
    // 恢复轨道的过渡效果
    sliderTrack.classList.add('not-dragging');
    
    // 恢复文本选择
    document.body.style.userSelect = '';
    document.body.style.webkitUserSelect = '';
    document.body.style.mozUserSelect = '';
    document.body.style.msUserSelect = '';
    
    // 从dataset获取当前位置
    const currentPosition = parseFloat(sliderButton.dataset.currentX) || 0;
    const progress = currentPosition / maxDistance;
    
    if (progress >= 0.9) { // 滑动到90%以上认为验证成功
      completeVerification();
    } else {
      // 滑动不够，回弹到起始位置
      resetSlider();
    }
  }

  function completeVerification() {
    form.sliderVerified = true;
    sliderContainer.classList.add('completed', 'success-animation');
    
    // 确保完成验证时有平滑的过渡效果
    sliderTrack.classList.add('not-dragging');
    
    sliderButton.style.transform = `translateX(${maxDistance}px)`;
    sliderButton.style.left = '0px';
    sliderTrack.style.width = '100%';
    sliderText.textContent = '太棒了！即将开始使用生意专家';
    sliderText.classList.add('success', 'success-animation');
    sliderText.style.opacity = 1;
    sliderText.style.zIndex = 3;
    
    // 更改按钮图标为对勾
    sliderButton.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="20,6 9,17 4,12"/></svg>';
    
    // 移除动画类
    setTimeout(() => {
      sliderContainer.classList.remove('success-animation');
      sliderText.classList.remove('success-animation');
    }, 800);
    
    if (form.account && /^1[3458769]\d{9}$/.test(form.account)) {
      setTimeout(() => {
        getSmsCode();
      }, 100);
    }
  }

  function resetSlider() {
    // 确保有过渡效果的回弹动画
    sliderTrack.classList.add('not-dragging');
    
    sliderButton.style.transform = 'translateX(0px)';
    sliderButton.style.left = '0px';
    sliderTrack.style.width = '0px';
    sliderText.style.opacity = 1;
    sliderButton.dataset.currentX = '0';
  }

  window.resetSliderVerification = function() {
    if (form.sliderVerified) {
      form.sliderVerified = false;
      
      sliderContainer.classList.remove('completed', 'success-animation');
      sliderText.classList.remove('success', 'success-animation');
      
      sliderText.textContent = '向右滑动完成验证';
      sliderText.style.zIndex = 1;
      
      // 重置按钮图标
      sliderButton.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="m9 18 6-6-6-6" /></svg>';
      
      resetSlider();
    }
  }
}
// ========== 新的滑块验证功能结束 ==========

// ========== 密码显示/隐藏功能 ==========
function initPasswordToggle() {
  const passwordFields = document.querySelectorAll('input[type="password"]');
  passwordFields.forEach(field => {
    const icon = field.parentElement.querySelector('img.password-toggle-icon');
    if (icon) {
      icon.addEventListener('click', function() {
        if (field.type === 'password') {
          field.type = 'text';
          icon.src = 'assets/img/eye-visible.png';
          icon.alt = '隐藏密码';
        } else {
          field.type = 'password';
          icon.src = 'assets/img/eye-hiden.png';
          icon.alt = '显示密码';
        }
      });
    }
  });
}
// ========== 密码显示/隐藏功能结束 ==========

// 手机验证码
function getSmsCode () {
  if (!isturn) {
    return;
  }

  var accountName = form.account;

  // const regPhone = /^1(3\d|4[5-9]|5[0-35-9]|6[2567]|7[0-8]|8\d|9[0-35-9])\d{8}$/
  const regPhone = /^1[3458769]\d{9}$/;
  if (!regPhone.test(accountName)) {
    alert('请输入正确手机号');
    // 手机号码格式错误时重置滑动验证
    resetSliderVerification();
    return;
  }

  // 检查滑块验证
  if (!form.sliderVerified) {
    alert('请先完成滑动验证！');
    return;
  }

  // 检查token是否已获取
  if (!token) {
    alert('系统初始化中，请稍后再试');
    // 系统异常时也重置滑动验证
    resetSliderVerification();
    return;
  }

  getSmsCapReq(form.account, token);
}

// 原版本获取短信验证码函数 (已修改，移除图形验证码依赖)
// function getSmsCapReq (captcha, account, token) {
//   const params = {
//     captcha: captcha,
//     phone: account,
//     token: token
//   }
//   const bodyJson = JSON.stringify(params);
//   let xhr = new XMLHttpRequest();
//   xhr.open('post', `${APP_API}/gatentry/apipub/reg/smscode` );
//   xhr.setRequestHeader("content-type","application/json;charset=utf-8");
//   xhr.setRequestHeader("token",token);
//   xhr.send(bodyJson);
//   xhr.onreadystatechange = function () {
//     if (xhr.readyState == 4 && xhr.status == 200) {
//       let resp = JSON.parse(xhr.response);
//       alert(resp.data.desc);
//       if (resp.code === 200 && resp.data.stat === '0000') {
//         setCapTTL(phoneCodebtn);
//         return;
//       }
//     } 
//   };
// }

// 新版本获取短信验证码函数 (使用滑块验证+token)
function getSmsCapReq (account, token) {
  const params = {
    phone: account,
    token: token
  }

  const bodyJson = JSON.stringify(params);

  let xhr = new XMLHttpRequest();
  xhr.open('post', `${APP_API}/gatentry/apipub/v1/reg/smscode` );
  xhr.setRequestHeader("content-type","application/json;charset=utf-8");
  xhr.setRequestHeader("token", token);
  xhr.send(bodyJson);
  xhr.onreadystatechange = function () {
      // 这步为判断服务器是否正确响应
    if (xhr.readyState == 4 && xhr.status == 200) {
      let resp = JSON.parse(xhr.response);

      console.log(xhr.response);

      alert(resp.data.desc);
      if (resp.code === 200 && resp.data.stat === '0000') {
        setCapTTL(phoneCodebtn);
        return;
      } else {
        resetSliderVerification();
      }
    } else if (xhr.readyState == 4) {
      resetSliderVerification();
    }
  };
}

function setCapTTL(smsCapBtn) {
  isturn = false;
  var count = 60;
  var countdown = setInterval(CountDown, 1000);

  smsCapBtn.setAttribute("disabled", 'disabled');
  function CountDown() {
    smsCapBtn.innerHTML = "" + count + " 秒后再试";
    if (count === 0) {
      smsCapBtn.innerHTML = "获取验证码";
      smsCapBtn.removeAttribute("disabled");
      clearInterval(countdown);
      isturn = true;
    }
    count--;
  }
}


function ShowErrMsg(id, message) {
  throw message;
}

